import React, { useEffect, useState } from "react";
import general from "../../../general";
import $ from "jquery";
import { useLockFn, useReactive, useScroll } from "ahooks";
import KeepScroll from "../../../lib/KeepScroll";
import { Link } from "react-router-dom";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import useUrlState from "@ahooksjs/use-url-state";

const types = [
  {
    id: "selling",
    text: "出售中",
  },
  {
    id: "buy",
    text: "已购买",
  },
  {
    id: "submit",
    text: "已提交",
  },
  {
    id: "sold",
    text: "已出售",
  },
];

export default (props) => {
  const [params, setParams] = useUrlState({}, { navigateMode: "replace" });
  const typeFromUrl = params?.tradeType != null ? Number(params.tradeType) : 0;
  const [typeIndex, setTypeIndex] = useState(typeFromUrl);

  useEffect(() => {
    if (params?.tradeType != null) {
      setTypeIndex(Number(params.tradeType));
    }
  }, [params?.tradeType]);

  const datas = useReactive(
    types.map((item) => ({
      id: item.id,
      text: item.text,
      init: false,
      loading: null,
      page: 1,
      more: null,
      datas: [],
    })),
  );
  const load = useLockFn(async (parms = {}) => {
    let data = datas[typeIndex];
    if (data.loading) {
      return;
    }
    data.loading = true;
    Dialog.loading();
    let tmp = {
      apply_type: 2,
      pagination: { count: 20, page: data.page },
    };
    if (data.id === "selling") {
      tmp.record_type = "2";
    }
    if (data.id === "buy") {
      tmp.record_type = "1";
    }
    if (data.id === "submit") {
      tmp.record_type = "3";
    }
    if (data.id === "sold") {
      tmp.record_type = "4";
    }
    console.log(tmp);
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }
    await general.axios
      .post("/v3/user/trade/getTradeList", tmp)
      .finally(() => {
        data.loading = false;
        Dialog.close();
      })
      .then((res) => {
        let { status, data: result } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        data.init = true;
        if (parms.page) {
          data.page = parms.page;
        }
        data.datas =
          parms.page === 1 || !parms.page
            ? result.account_list
            : [...data.datas, ...result.account_list];
        data.more = result?.paginated?.more && result?.account_list?.length > 0;
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  });

  useEffect(() => {
    if (props.active && !datas[typeIndex].init) {
      load();
    }
  }, [props.active, typeIndex]);

  useEffect(() => {
    if (props.active) {
      load({ page: 1 });
    }
  }, [props.active]);

  const scroll = useScroll();
  useEffect(() => {
    let data = datas[typeIndex];
    if (props.active && data.init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 >= $(document).height() &&
        data.init &&
        data.more
      ) {
        load({ page: data.page + 1 });
      }
    }
  }, [scroll, props.active]);

  const offShelf = useLockFn(async (trade) => {
    Dialog.loading();
    await general.axios
      .post("/v3/user/trade/opetateTrade", {
        trade_id: trade.trade_id,
        trade_status: "-1",
        username: undefined,
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          Dialog.success("下架成功");
          load({ page: 1 });
        }
      })
      .catch((err) => {
        Dialog.error("opetateTrade " + err.message);
      });
  });

  return (
    <div className="trade-record">
      <div
        className="record-head"
        style={{
          top: `calc(env(safe-area-inset-top) + ${props.size?.height || 45}px)`,
        }}
      >
        {types.map((item, index) => (
          <div
            key={index}
            className={"item" + (index === typeIndex ? " active" : "")}
            onClick={() => {
              setTypeIndex(index);
              setParams({ ...params, tradeType: index });
            }}
          >
            {item.text}
          </div>
        ))}
      </div>

      <div className="record-body">
        {datas.map((type, index) => (
          <div
            key={index}
            className={
              "type-item type-item-" +
              type.id +
              (index === typeIndex ? " active" : "")
            }
          >
            <KeepScroll active={index === typeIndex}>
              <div className="items">
                {type.datas.map((trade) => (
                  <Link
                    key={trade.trade_id}
                    to={"/trade/detail?id=" + trade.trade_id}
                    className={"item" + (trade.operable ? " operable" : "")}
                  >
                    <div
                      className="main"
                      style={{
                        alignItems:
                          type.id === "submit" || type.id === "selling"
                            ? "center"
                            : "flex-end",
                      }}
                    >
                      <div className="main-left">
                        <div className="icon">
                          <Image src={trade.game_icon} />
                        </div>

                        <div className="info">
                          <div className="name">
                            {trade.game_name_main || trade.game_name}

                            {trade.game_name_branch ? (
                              <div className="branch">
                                {trade.game_name_branch}
                              </div>
                            ) : null}
                          </div>

                          <div className="title">{trade.title}</div>

                          <div className="amount-price">
                            <div className="amount">
                              实际充值：{trade.total_amount}
                            </div>
                            <div className="price">¥{trade.trade_price}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="data"
                      style={{
                        paddingTop:
                          type.id === "submit" || type.id === "selling"
                            ? "0"
                            : "16px",
                      }}
                    >
                      <div className="time">上架时间：{trade.sell_time}</div>

                      {(type.id === "submit" || type.id === "selling") && (
                        <div className="operate">
                          <div
                            className="operate-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              Dialog.operation({
                                title: "下架提醒",
                                closeShow: false,
                                content: (
                                  <div>
                                    <p style={{ textAlign: "center" }}>
                                      下架后该商品将不再展示
                                    </p>
                                    <p style={{ textAlign: "center" }}>
                                      是否继续？
                                    </p>
                                  </div>
                                ),
                                btns: [
                                  {
                                    text: "确认下架",
                                    style: "success",

                                    onPress: () => offShelf(trade),
                                  },
                                  { text: "取消", style: "cancel" },
                                ],
                              });
                            }}
                          >
                            下架
                          </div>
                        </div>
                      )}
                    </div>
                  </Link>
                ))}
              </div>
              {type.datas.length === 0 && type.init ? (
                <div className="recovery-empty">
                  <img src="/resources/recovery/empty.png" alt="" />
                  暂无数据
                </div>
              ) : null}

              {type.datas.length > 0 && type.init && !type.more ? (
                <div className="view-end">无更多数据</div>
              ) : null}
            </KeepScroll>
          </div>
        ))}
      </div>
    </div>
  );
};
